module.exports = __webpack_public_path__ + "static/media/7.5691b1e3.jpg";